import {
    ALTERNATIVE_BIKE_SUCCESS,
    ALTERNATIVE_BIKE_ERROR,
    ALTERNATIVE_BIKE_START,
} from "Constant";


const initialState = {
    loading: false,
    data: [],
    message: ""
};

export default function AlternativeBikeReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case ALTERNATIVE_BIKE_START:
            return {
                ...state,
                data: [],
                loading: true,
            };
        case ALTERNATIVE_BIKE_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case ALTERNATIVE_BIKE_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
